export class FaqManager {

    constructor(private containerElement: JQuery) {
    }

    private faqList : JQuery<HTMLElement>;
    private searchInput : JQuery<HTMLElement>;

    private faqWidgetId : string;

    public initialize() {
        
        this.faqList = this.containerElement.find('#faqList');
        this.faqWidgetId = this.faqList.data('faq-widget-id');

        var form = this.containerElement.find("#search-faq-form");
        this.searchInput = form.find('#searching');
        $(form).submit(e => {
            e.preventDefault();

            this.loadFaqBlock();
        });

        this.loadFaqBlock();
    }

    loadFaqBlock() {

        let url = `/faq/faqList?faqWidgetId=${this.faqWidgetId}`;

        if (this.searchInput.val() != undefined) {
            url = `${url}&search=${this.searchInput.val()}`;
        }

        this.faqList.load(
            encodeURI(url), () => {   
                this.faqList.find(".faq").each(function(){
                    $(this).on("click", function(e){
                        if($(this).hasClass('faq__open')){
                            $(this).removeClass('faq__open');
                            $(this).find('.faq__text').addClass("d-none");
                            $(this).find('.faq__icon').addClass(' fa-chevron-down');
                            $(this).find('.faq__icon').removeClass(' fa-chevron-up');
                            $(this).find('.dropdown').removeClass('d-none');
                            $(this).find('.dropdown-close').addClass('d-none');

                        }
                        else{
                            $(this).addClass('faq__open');
                            $(this).find('.faq__text').removeClass("d-none")
                            $(this).find('.faq__icon').removeClass('fa-chevron-down');
                            $(this).find('.faq__icon').addClass('fa-chevron-up');
                            $(this).find('.dropdown').addClass('d-none');
                            $(this).find('.dropdown-close').removeClass('d-none');
                        }
                    });
                })
            });
    }
}